"use strict";

angular.module("imagetrend.components").directive("inspectionPdf", [
    function() {
        return {
            restrict: "AE",
            templateUrl: "templates/inspection-pdf/inspection-pdf.html",
            scope: {
                inspection: "=?"
            },
            replace: true,
            link: function (scope, elem, attrs, ctrl) {
                scope.deficiencyScore = { score: 0 };
                // Decodes header and footer for PDF
                function decodeHtml(encodedHtml) {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = encodedHtml;
                    return txt.value;
                }
                if (scope.inspection.checklist.template.header != null) {
                    scope.inspection.checklist.template.header = decodeHtml(
                        scope.inspection.checklist.template.header
                    );
                }
                if (scope.inspection.checklist.template.footer != null) {
                    scope.inspection.checklist.template.footer = decodeHtml(
                        scope.inspection.checklist.template.footer
                    );
                }

                scope.$on("$destroy", function() {
                    if (elem) {
                        angular.element(elem).off();
                        angular.element(elem).remove();
                        elem = null;
                    }
                });

                if (scope.inspection.checklist.template !== null && scope.inspection.id !== null) {
                    scope.inspection.passingChecklist = scope.inspection.checklist.template;
                    scope.inspection.passingChecklist.inspectionID = scope.inspection.id;
                    scope.inspection.passingChecklist.comments = scope.inspection.comments;

                    if (scope.inspection.checklist.template.require_responsible_party_signoff === true && (scope.inspection.checklist.signature_type_in_person === null || scope.inspection.checklist.signature_type_in_person === undefined)) {
                        scope.inspection.checklist.signature_type_in_person = true;
                    }
                }
            }
        };
    }
]);
